import React from 'react';
import DateFnsUtils from '@date-io/date-fns';
import {handleDateChange} from '@pluto/utils';
import {
    KeyboardDateTimePicker,
    MuiPickersUtilsProvider,
} from '@material-ui/pickers';

export default function ConfigPublishedDate(props: any) {
    const {
        isValidDate,
        publishedDateField,
        dateValue,
    } = props;
    const handleChange = handleDateChange(publishedDateField, isValidDate);
    return (
        <div className="new-ingest-form__field">
            <div className="new-ingest-form__field-label">
                Ingest Content Published as of
            </div>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDateTimePicker
                    autoOk
                    inputVariant="outlined"
                    variant="inline"
                    format="MM-dd-yyyy HH:mm"
                    margin="normal"
                    placeholder="MM-dd-yyyy HH:mm"
                    value={dateValue || null}
                    onChange={handleChange}
                    ampm={false}
                />
            </MuiPickersUtilsProvider>
        </div>
    );
}

